import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./DailyActivityChartStyles";
import HourlyTick from "./HourlyTick";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  YAxis,
  CartesianGrid,
  Rectangle,
} from "recharts";
import { colour } from "../style/base-theme";
import moment from "moment";
import Sticky from "react-stickynode";

let data = [];

let overallCounter = 0;

const timesArray = [
  "0000",
  "0100",
  "0200",
  "0300",
  "0400",
  "0500",
  "0600",
  "0700",
  "0800",
  "0900",
  "1000",
  "1100",
  "1200",
  "1300",
  "1400",
  "1500",
  "1600",
  "1700",
  "1800",
  "1900",
  "2000",
  "2100",
  "2200",
  "2300",
  "2400",
];

const fills = {
  off: "transparent",
  Normal: "#00C5FF",
  Warning: "url(#offHash)",
  Urgent: "url(#offHash)",
};

const CustomBar = (props) => {
  let { fill, value, payload, width, x } = props;

  Object.keys(payload.data).filter((item) => {
    if (
      value[0] === payload.data[item][0] &&
      value[1] === payload.data[item][1]
    ) {
      return (fill = fills[payload.data[item][2]]);
    }
    return false;
  });

  return (
    <Rectangle
      {...props}
      fill={fill}
      width={width - 11}
      x={x + 5}
      className={`recharts-bar-rectangle`}
    />
  );
};

class DailyActivityChart extends Component {
  constructor(props) {
    super(props);
    const { detail } = props.activity;
    let { detailItem } = props.activity;

    if (detailItem == 0) {
      detailItem = moment().unix();
    }

    data =
      detail.activities.length &&
      detail.activities.map((item) => {
        let previousEnd = 0;
        let counter = 0;
        let parts = {};
        parts.name = item.activity_type;
        parts.id = item.activity_id;
        parts.on = moment.unix(detailItem).startOf("day").unix();
        parts.off = moment.unix(detailItem).endOf("day").unix();
        parts.icon = item.icon;
        parts.dispatch = this.props.dispatch;
        parts.history = this.props.history;
        let data = [];
        for (var i = 0; i < item.patterns.length; i++) {
          const part = item.patterns[i];

          if (part.inactivity) {
            const testStart =
              part.inactivity.off !== undefined &&
              moment.unix(part.inactivity.off).format("HH:mm");

            const testEnd = moment.unix(part.inactivity.on).format("HH:mm");

            const startHours = testStart.split(":")[0];
            let startMinutes = Math.round(
              Number(testStart.split(":")[1]) / 0.6
            );
            startMinutes =
              startMinutes < 10 ? "0" + startMinutes : startMinutes;

            const endHours = testEnd.split(":")[0];
            let endMinutes = Math.round(Number(testEnd.split(":")[1]) / 0.6);
            endMinutes = endMinutes < 10 ? "0" + endMinutes : endMinutes;

            const start = Number(`${startHours}${startMinutes}`);
            const end = Number(`${endHours}${endMinutes}`);

            parts[counter] = start - previousEnd;
            let newEnd = end;
            if (end - start <= 0) {
              newEnd = 2400;
            }
            parts[counter + 1] = newEnd - start;
            data.push([previousEnd, start, "off"]);
            data.push([
              start,
              newEnd,
              item.patterns[i].level,
              part.inactivity.on,
              part.inactivity.off,
            ]);
            previousEnd = newEnd;
            counter += 2;
          }
        }
        if (counter > overallCounter) overallCounter = counter;
        parts.data = data;
        return parts;
      });
  }

  handleClick(props) {
    props.data.map((item) => {
      if (
        item[0] === props.value[0] &&
        item[2] !== "off" &&
        item[2] !== "Normal"
      ) {
        props.history.push(
          `activities/alert/${props.id}?on=${item[4]}&off=${item[3]}`
        );
      }

      return false;
    });
  }

  render() {
    if (!data) return false;

    const barList = [];

    barList.push(
      <Bar
        shape={CustomBar}
        background={{ fill: "#ffffff", stroke: `${colour.grey[500]}` }}
        type="monotone"
        dataKey={0}
        stackId="a"
        onClick={this.handleClick}
        key={1}
      />
    );

    for (var i = 1; i < overallCounter; i++) {
      barList.push(
        <Bar
          shape={CustomBar}
          type="monotone"
          dataKey={i}
          stackId="a"
          onClick={this.handleClick}
          key={i + 1}
        />
      );
    }

    const ChartX = () => (
      <div className={css(styles.chartX)}>
        {data.map((item, i) => {
          return (
            <a
              className={css(styles.chartXItem)}
              href={`activities/${item.id}?on=${item.on}&off=${item.off}`}
              key={i}
            >
              <img
                className={css(styles.chartXIcon)}
                src={item.icon}
                alt={`${item.name} icon`}
              />
              <strong className={css(styles.chartXTitle)}>{item.name}</strong>
            </a>
          );
        })}
      </div>
    );

    return (
      <div className={css(styles.chartWrapper)} ref="header">
        <Sticky top="#header" innerZ={200}>
          <ChartX />
        </Sticky>
        <ResponsiveContainer>
          <BarChart
            width={600}
            height={600}
            data={data}
            barCategoryGap={-1}
            margin={{ top: 25, right: 15, left: -25, bottom: 0 }}
          >
            <defs>
              <pattern
                id="urgentHash"
                width="4"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(-45 50 50)"
              >
                <line
                  stroke={colour.brand.red}
                  opacity={0.5}
                  strokeWidth="20px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[200]}
                  opacity={0.5}
                  strokeWidth="2px"
                  y2="10"
                />
              </pattern>
              <pattern
                id="offHash"
                width="14"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(45 50 50)"
              >
                <line
                  stroke={colour.brand.purple}
                  opacity={1}
                  strokeWidth="28px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[200]}
                  opacity={0.5}
                  strokeWidth="5px"
                  y2="10"
                />
              </pattern>
              <pattern
                id="warningHash"
                width="14"
                height="10"
                patternUnits="userSpaceOnUse"
                patternTransform="rotate(-45 50 50)"
              >
                <line
                  stroke={colour.assisted.primaryGradientTop}
                  opacity={0.5}
                  strokeWidth="28px"
                  y2="10"
                />
                <line
                  stroke={colour.grey[300]}
                  opacity={0.5}
                  strokeWidth="5px"
                  y2="10"
                />
              </pattern>
            </defs>
            <YAxis
              reversed={true}
              tickLine={false}
              ticks={timesArray}
              domain={[0, 2400]}
              tick={<HourlyTick />}
              stroke={colour.grey[300]}
              fontFamily="Source Sans Pro"
              fontSize={14}
            />
            {barList}
            <CartesianGrid stroke={colour.grey[500]} vertical={false} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  }
}

export default withRouter(DailyActivityChart);
